// extracted by mini-css-extract-plugin
module.exports = {"seriesListWrapper":"pE","fullWidth":"pF","seriesListTabWrapper":"pG","tab":"pH","active":"pI"};